module.exports = __webpack_public_path__ + "media/MRI10.772ed8a3.mp3";